import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"elevation-12"},[_c(VCardText,[_c(VAlert,{attrs:{"value":true,"color":"success","icon":"check_circle","outlined":""}},[_c('i18n',{attrs:{"path":"auth.activationSent","tag":"p"},scopedSlots:_vm._u([{key:"email",fn:function(){return [_c('strong',[_vm._v(_vm._s(_vm.email))])]},proxy:true}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }